import { render, staticRenderFns } from "./UpdatePolicy.vue?vue&type=template&id=c6264b36"
import script from "./UpdatePolicy.vue?vue&type=script&lang=js"
export * from "./UpdatePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports